"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProfileMutationOptions = exports.updateProfile = void 0;
const client_1 = require("@apollo/client");
const common_1 = require("@saffron/common");
const me_1 = require("../queries/me");
exports.updateProfile = client_1.gql `
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      ok
    }
  }
`;
exports.updateProfileMutationOptions = (variables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        updateProfile: {
            __typename: "OkResponse",
            ok: true,
        },
    },
    update: store => {
        try {
            const data = store.readQuery({
                query: me_1.meQuery,
            });
            if (data) {
                store.writeQuery({
                    query: me_1.meQuery,
                    data: {
                        __typename: "Query",
                        me: {
                            __typename: "UserResponse",
                            user: Object.assign(Object.assign({}, data.me.user), common_1.pluckDefined(variables.input)),
                        },
                    },
                });
            }
        }
        catch (e) {
            if (process.env.NODE_ENV === "development") {
                console.log(e);
            }
        }
    },
});
//# sourceMappingURL=updateProfile.js.map